import DataImport from './DataImport';
export default DataImport;